import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UserMenu from './UserMenu';
import { openPrimaryDownload } from '../lib/downloads';
import LanguageSwitcherButton from './LanguageSwitcherButton';

const AppBarSimple = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('common');

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar color="default" elevation={1} position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography onClick={() => { navigate('/login'); }} variant="span" component="div" sx={{ cursor: 'pointer' }} color="primary">
            <b>GAME VISION PRO</b>
          </Typography>

          <Box sx={{ ml: 2, flexGrow: 1, display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }} />

          <Box sx={{ flexGrow: 1, display: { sm: 'none', xs: 'flex' }, alignItems: 'center' }} />

          <LanguageSwitcherButton sx={{ mr: 2 }} />

          {!window.electron && location.pathname !== '/download' && (
            <Button sx={{ mr: 2 }} onClick={() => { openPrimaryDownload(); }} variant="contained" size="small">
              {t('actions.freeDownload')}
            </Button>
          )}

          <UserMenu />
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default AppBarSimple;
